import {
  ApplicationConfig,
  inject,
  isDevMode,
  PLATFORM_ID,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners
} from '@angular/core';
import {
  provideRouter,
  Router,
  withComponentInputBinding,
  withHashLocation,
  withInMemoryScrolling,
  withRouterConfig
} from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { apiInterceptor } from '@core/interceptors/api.interceptor';
import { loadingInterceptor } from '@core/interceptors/loading.interceptor';
import { isPlatformBrowser } from '@angular/common';
import { APP_CONFIG, STORAGE_CONFIG } from '@core/constants';
import { SessionStore } from '@store/session.store';
import { StorageService } from '@services/storage.service';
import { DeviceDetectorService } from 'ngx-device-detector';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withHashLocation(),
      withRouterConfig({
        paramsInheritanceStrategy: 'always'
      }),
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
      })
    ),
    {
      provide: APP_CONFIG,
      useValue: {
        baseUrl: '/middleware',
        imgBase: '/img/'
      }
    },
    {
      provide: STORAGE_CONFIG,
      useValue: {
        session: 'coffee_session',
        user: 'user_session',
        favorites: 'favorites'
      }
    },
    provideAppInitializer(() => {
      const platformId = inject(PLATFORM_ID);
      if (isPlatformBrowser(platformId)) {

        const router = inject(Router);
        const url = window.location.href;


        const storageKey = inject(STORAGE_CONFIG);
        const sessionStore = inject(SessionStore);
        const storageService = inject(StorageService);

        const uuidMatch = url.match(/splash\/([a-zA-Z0-9-]+)/);
        let tableUuid: string | null = null;

        if (uuidMatch && uuidMatch[1] && uuidMatch[1] !== 'undefined') {
          tableUuid = uuidMatch[1].toLowerCase();
          localStorage.setItem('table_uid', tableUuid);
          sessionStore.setTable(tableUuid);
        }


        if (tableUuid) {
          const savedSession = localStorage.getItem(storageKey.session);
          if (savedSession) {
            try {
              const parsed = JSON.parse(savedSession);

              const savedUser = JSON.parse(localStorage.getItem(storageKey.user) || '{}');
              if (savedUser.tableUID !== tableUuid) {
                storageService.clear();
              }
            } catch (e) {
              storageService.clear();
            }
          }
        }


        const sessionRaw = localStorage.getItem(storageKey.session);
        if (sessionRaw) {
          try {
            const { customerId } = JSON.parse(sessionRaw);
            if (customerId) {
              sessionStore.reloadSession({
                customerId,
                onSuccess: () => router.navigate(['/standard/categories'], { replaceUrl: true }),
                onError: () => {
                  storageService.clear();
                  router.navigate(['/'], { replaceUrl: true });
                }
              });
            }
          } catch (e) {
            // Error silencioso parseo
          }
        }
      }
    }),
    provideHttpClient(withInterceptors([apiInterceptor, loadingInterceptor])),
  ]
};
